import React from "react";
import {
    Box,
    CircularProgress,
} from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import CustomSnackbar from "../components/Message.Component";
import { CatalogProvider, useCatalogContext } from "./components/products/CatalogContext";
import CatalogFilterDrawer from "./components/products/CatalogFilterDrawer";
import CatalogFilterPanel from "./components/products/CatalogFilterPanel";
import CatalogHeader from "./components/products/CatalogHeader";
import CatalogStatusBar from "./components/products/CatalogStatusBar";
import CatalogActionDialog from "./components/products/CatalogActionDialog";
import CatalogSelectionToolbar from "./components/products/CatalogSelectionToolbar";
import CatalogPagination from "./components/products/CatalogPagination";
import VirtualizedProductGrid from "./components/products/VirtualizedProductGrid";
import VirtualizedProductList from "./components/products/VirtualizedProductList";
import CmvImportDialog from "./components/products/CmvImportDialog";

export default function CatalogoPage() {
    return (
        <CatalogProvider>
            <CatalogPage />
        </CatalogProvider>
    );
}

function CatalogPage() {
    
    const {
        alert,
        setAlert,
        severity,
        message,
        produtos,
        loading,
        viewMode,
    } = useCatalogContext();

    return (
        <React.Fragment>
            <CustomSnackbar
                open={alert}
                onClose={() => setAlert(false)}
                severity={severity}
                message={message} />            <CatalogActionDialog />
            <CatalogFilterDrawer />
            <CmvImportDialog />

            <Box sx={{ 
                paddingTop: { xs: 1.5, sm: 2, md: 3 },
                paddingRight: { xs: 1.5, sm: 2, md: 3 },
                paddingLeft: { xs: 1.5, sm: 2, md: 3 } ,
                height: 'auto', bgcolor: '#fafafa', display: 'flex', flexDirection: 'column', minHeight: 0, pb: 0 }}>
                <CatalogStatusBar />
                <CatalogHeader />
                <CatalogFilterPanel />

                {/* Grid/Lista de Produtos */}
                <Box sx={{ overflowY: 'auto', display: 'flex', flexDirection: 'column', margin: 0 }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 4, height: 200 }}>
                            <CircularProgress size={50} sx={{ color: "#ff9800" }} />
                        </Box>
                    ) : produtos.length === 0 ? (
                        <Box sx={{ p: 4, textAlign: 'center', borderRadius: 2, height: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box sx={{ color: 'text.secondary', mb: 2 }}>
                                <InventoryIcon sx={{ fontSize: 48 }} />
                            </Box>
                            <Box sx={{ variant: "h6", color: 'text.secondary' }}>
                                Nenhum produto encontrado
                            </Box>
                            <Box sx={{ variant: "body2", color: 'text.secondary', mt: 1 }}>
                                Tente ajustar seus filtros de busca
                            </Box>
                        </Box>
                    ) : viewMode === 'grid' ? (
                        // Visualização em Grade (Cards) - agora virtualizada
                        <VirtualizedProductGrid produtos={produtos} getProductId={getProductId} />
                    ) : (
                        // Visualização em Lista - agora virtualizada
                        <VirtualizedProductList produtos={produtos} getProductId={getProductId} style={{ flex: 1, minHeight: 0 }} />
                    )}
                </Box>

                <CatalogSelectionToolbar sx={{ my: 0, py: 0 }} />
                <CatalogPagination />

                {/* Botão flutuante para adicionar novo produto */}
                {/* <Fab
                    aria-label="adicionar produto"
                    onClick={handleCreateProduto}
                    sx={{
                        position: "fixed",
                        bottom: 32,
                        right: 32,
                        boxShadow: "0 4px 16px rgba(247, 208, 191, 0.7)",
                        backgroundColor: "#f7d0bf",
                        color: "black",
                        width: 64,
                        height: 64,
                        "&:hover": {
                            backgroundColor: "#f5c1a9",
                            boxShadow: "0 6px 20px rgba(247, 208, 191, 0.9)",
                            transform: "scale(1.05)"
                        },
                        transition: "all 0.2s"
                    }}
                >
                    <AddIcon sx={{ fontSize: 28 }} />
                </Fab> */}
            </Box>
        </React.Fragment>
    );
}

// Utilitário para garantir ID único e estável
function getProductId(produto) {
    return produto.id || produto._id;
}
